<template>
  <div class="waterMarker" ref="canvasD"></div>
</template>
<script>
export default {
  name: 'WaterMarker',
  props: {
    text: {
      type: String,
      required: true
    },
    textStyle: {
      type: Object
    }
  },
  data () {
    return {
      defaultOption: {
        text: ''
      },
      defaultTextStyle: {
        rotate: 30,
        fontSize: parseInt(document.getElementsByTagName('html')[0].style.fontSize) * 0.8,
        fontFamily: 'Microsoft JhengHei',
        color: 'rgba(180, 180, 180, 0.3)',
        textAlign: 'left',
        verticalAlign: 'Middle'
      }
    }
  },
  mounted () {
    let width = document.body.clientWidth
    let height = document.body.clientHeight
    let option = Object.assign(this.defaultOption, {text: this.text})
    let textStyle = Object.assign(this.defaultTextStyle, this.textStyle)
    if (width > height) {
      option.width = option.height = width * Math.SQRT2
    } else {
      option.width = option.height = height * Math.SQRT2
    }
    this.makeMarker(option, textStyle)
  },
  methods: {
    makeMarker (option, textStyle) {
      if (!option.text) { return false }
      let can = document.createElement('canvas')
      this.$refs.canvasD.appendChild(can)
      can.width = option.width
      can.height = option.height
      let cans = can.getContext('2d')
      let deg = textStyle.rotate * Math.PI / 180
      let fillTextWidth = 0
      let fillTextHeight = 0
      let pre = 0.6 + (0.05 * option.text.length)
      cans.font = textStyle.fontSize + 'px ' + textStyle.fontFamily
      cans.fillStyle = textStyle.color
      cans.textAlign = textStyle.textAlign
      cans.textBaseline = textStyle.verticalAlign
      if (deg > 0) {
        fillTextWidth = Math.floor(cans.measureText(option.text).width / pre * Math.cos(deg))
        fillTextHeight = Math.floor(cans.measureText(option.text).width / pre * Math.sin(deg))
        cans.rotate(-deg)
        cans.translate(-option.width / 4, -option.height / 4)
      } else {
        fillTextWidth = Math.floor(cans.measureText(option.text).width / pre)
        fillTextHeight = Math.floor(cans.measureText(option.text).width / pre)
      }
      let rowCount = Math.floor(option.width / fillTextWidth)
      let colCount = Math.floor(option.height / fillTextHeight)
      for (let i = 0; i < colCount; i++) {
        for (let j = 0; j < rowCount; j++) {
          if (j % 2 === 1 && i % 2 === 1) {
            cans.fillText(option.text, fillTextWidth * j, fillTextHeight * i)
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .waterMarker {
    position: fixed;
    top: calc(60vw / 19.2);
    width: 100%;
    height: calc(100vh - (160vw / 19.2));
    overflow: hidden;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// WaterMarker.vue?57db67cb